import DocumentPreview from '@/components/TaskHub/DocumentPreview';
import { useDocument } from '@/context/DocumentContext';
import React from 'react';
import SlidingPanel from 'react-sliding-side-panel';

const DocViewer = () => {
  const { documentId, setDocumentId } = useDocument();

  const closeDocument = () => {
    setDocumentId(null);
  };

  if (!documentId) {
    return null;
  }

  const size = window.innerWidth > 768 ? 60 : 80;

  return (
    <div className="fixed inset-0 z-50">
      <SlidingPanel
        backdropClicked={closeDocument}
        className="relative z-50"
        isOpen={!!documentId}
        onClose={closeDocument}
        size={size}
        type="left"
      >
        <div className="h-screen bg-white p-3">
          <DocumentPreview documentId={documentId} />
        </div>
      </SlidingPanel>
    </div>
  );
};

export default DocViewer;
